import { Box, Button, Modal, Title } from '@mantine/core'
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { useCallback, useState } from 'react'
import { notifications } from '@mantine/notifications'
import { IconAlertCircle } from '@tabler/icons-react'

export default function EmbeddedCheckoutButton({
  buttonText,
  priceIds,
  ...buttonProps
}) {
  const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY)
  const [showCheckout, setShowCheckout] = useState(false)

  const fetchClientSecret = useCallback(async () => {
    try {
      // Create a Checkout Session
      const response = await fetch('/api/embedded-checkout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ priceIds })
      })

      const data = await response.json()

      if (!response.ok) {
        if (data.code === 'SUBSCRIPTION_ALREADY_EXISTS') {
          notifications.show({
            title: 'Suscripción ya activa',
            message: data.message,
            color: 'yellow',
            icon: <IconAlertCircle size={16} />,
            autoClose: 5000
          })
          return null
        }
        throw new Error(data.message || 'Error al crear la sesión de checkout')
      }

      return data.client_secret
    } catch (error) {
      console.error('Error:', error)
      notifications.show({
        title: 'Error',
        message: error.message || 'Ocurrió un error al procesar tu solicitud',
        color: 'red',
        autoClose: 5000
      })
      return null
    }
  }, [priceIds])

  const options = { fetchClientSecret }

  const handleCheckoutClick = async () => {
    const clientSecret = await fetchClientSecret()
    if (clientSecret) {
      setShowCheckout(true)
    }
  }

  const handleCloseModal = () => {
    setShowCheckout(false)
  }

  return (
    <Box id="checkout" my="md">
      <Button onClick={handleCheckoutClick} {...buttonProps}>
        {buttonText}
      </Button>

      <Modal
        opened={showCheckout}
        onClose={handleCloseModal}
        title={<Title order={3}>Checkout</Title>}
        size="xl"
      >
        <Box py="md">
          {showCheckout && (
            <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          )}
        </Box>
      </Modal>
    </Box>
  )
}
